import { render, staticRenderFns } from "./Otps.vue?vue&type=template&id=5e321ebc&"
import script from "./Otps.vue?vue&type=script&lang=js&"
export * from "./Otps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports